import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Loader2, RefreshCw, Replace } from "lucide-react";
import { t, tf } from "@/lib/i18n";

const Option = ({ value, current, onPick, icon: Icon, title, desc, danger }) => (
  <button type="button" onClick={() => onPick(value)} data-testid={`import-mode-${value}`}
    className={`w-full text-left rounded-xl border-2 p-4 transition-colors ${current === value ? (danger ? "border-red-500 bg-red-50" : "border-primary bg-accent") : "border-border hover:border-primary/40"}`}>
    <span className="flex items-center gap-2 font-semibold text-sm"><Icon className={`h-4 w-4 ${danger ? "text-red-600" : "text-primary"}`} /> {title}</span>
    <span className="block text-xs text-muted-foreground mt-1">{desc}</span>
  </button>
);

export function ImportDialog({ rows, mode, setMode, existing, onClose, onConfirm, busy }) {
  const codes = new Set(existing.map((p) => p.code));
  const updates = (rows || []).filter((r) => codes.has(r.code.trim())).length;
  const adds = (rows?.length || 0) - updates;
  return (
    <Dialog open={!!rows} onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="import-dialog">
        <DialogHeader><DialogTitle>{t("Importa")} {rows?.length || 0} {t("prodotti")}</DialogTitle></DialogHeader>
        <div className="space-y-3">
          <Option value="upsert" current={mode} onPick={setMode} icon={RefreshCw} title={t("Aggiungi / aggiorna (consigliato)")}
            desc={tf("{a} nuovi prodotti verranno aggiunti, {u} con lo stesso codice verranno aggiornati. Gli altri prodotti restano invariati.", { a: adds, u: updates })} />
          <Option value="replace" current={mode} onPick={setMode} icon={Replace} danger title={t("Sostituisci tutto")}
            desc={tf("Elimina tutti i {n} prodotti attuali e carica solo quelli del file.", { n: existing.length })} />
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onClose} data-testid="import-cancel-btn">{t("Annulla")}</Button>
          <Button onClick={onConfirm} disabled={busy} className={mode === "replace" ? "bg-red-600 hover:bg-red-700" : ""} data-testid="import-confirm-btn">
            {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : mode === "replace" ? t("Sostituisci catalogo") : t("Importa")}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
